import React from "react";
import { useIntl } from "react-intl";
import { Box, Grid } from "@mui/material";
import { LocaleDropdown } from "@packsize/localization";

import { useAuthentication } from "../../hooks";
import { ApplicationIcon } from "../application-icon";
import packnetSoftwareSide from "../../assets/packnet-software-side.jpg";
import packnetSupportSide from "../../assets/packnet-support-side.jpg";

const AuthenticationSideImage = () => {
	const intl = useIntl();
	const { applicationName } = useAuthentication();

	const getSrc = () => {
		if (applicationName === "Support") {
			return packnetSupportSide;
		}

		return packnetSoftwareSide;
	};

	return (
		<Grid container sx={{ flex: 1, position: "relative", display: { xs: "none", md: "flex" } }}>
			<Box
				component="img"
				src={getSrc()}
				alt={intl.formatMessage({ id: "login.software-side-image-alt", defaultMessage: "PackNet background" })}
				sx={{
					width: "100%",
					height: "100%",
					objectFit: "cover",
					objectPosition: "center",
				}}
			/>
		</Grid>
	);
};

interface ContainerProps {
	readonly children: React.ReactNode;
}

export const AuthenticationContainer: React.FC<ContainerProps> = ({ children }) => {
	return (
		<Grid container sx={{ height: "100vh", width: "100vw", backgroundColor: "#022b3d", overflow: "auto" }}>
			<Box sx={{ position: "fixed", top: 16, right: 16, zIndex: 10 }}>
				<LocaleDropdown mode="preAuth" buttonProps={{ color: "info", sx: { minWidth: 120 } }} />
			</Box>

			<AuthenticationSideImage />

			<Grid container sx={{ flex: "2 1 0" }} alignItems="center" justifyContent="center">
				{children}
			</Grid>

			<ApplicationIcon sx={{ position: "absolute", bottom: 24, left: 24, width: 44, height: 44 }} />
		</Grid>
	);
};
